import { Phone, Mail, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";

export const Copyright = () => {
    const { t } = useTranslation();

    return (
        <>
            <footer className="bg-[#1A2B3C] text-white py-4">
                <div className="container mx-auto px-4 text-center">
                    <p>{t("copyright.content")}</p>
                </div>
            </footer>
        </>
    );
};